import script from "./LocalNotification.vue?vue&type=script&lang=ts&setup=true"
export * from "./LocalNotification.vue?vue&type=script&lang=ts&setup=true"

import "./LocalNotification.vue?vue&type=style&index=0&id=18745fca&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-18745fca"]])

export default __exports__